<div *ngIf="visible" id="machine_popup" class="popup-content">
    <b>{{name}}</b>
    <p>{{speed}} {{'Unit__km_h' | translate}}</p>
    <p>{{date}}</p>
</div>
